import type {SettlementPaymentMethodPayload} from '@/types';

import type {SettlementAccountAction} from './types';
import {SettlementAccountActionType} from './types';

const updateSettlementAccountReducer = (
  state: Partial<SettlementPaymentMethodPayload>,
  action: SettlementAccountAction,
): Partial<SettlementPaymentMethodPayload> => {
  switch (action.type) {
    case SettlementAccountActionType.UPDATE_SETTLEMENT_ACCOUNT:
      return {
        ...state,
        ...action.payload,
      };

    // Replaces rather than merges, so reopening the modal on a different
    // account cannot leave a field behind from the previous one.
    case SettlementAccountActionType.RESET_SETTLEMENT_ACCOUNT:
      return {...action.payload};

    default:
      return state;
  }
};

export default updateSettlementAccountReducer;
